import React from 'react'
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core'
import { get } from 'lodash'
import clsx from 'clsx'
import Graph from '../../OrganisationalCompensation/Graph'
import {useStyles, StyledTableCell, StyledTableRow } from '../styles'

export default function CurrentHeadCountDetailReport(props) {

	const classes = useStyles()

	return (
		<div className={classes.reportTableContainer}>
			<Table id="CurrentHeadCountDetailReport" className={classes.reportTable} size="small">
				<TableHead>
					<TableRow>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
							{
								props.groups.map(group=>
									<React.Fragment key={group}>
										<StyledTableCell colSpan={4}>{props.groupsNames[group]}</StyledTableCell>
										<StyledTableCell className={classes.noBorder}></StyledTableCell>
									</React.Fragment>
								)
							}
					</TableRow>
					<TableRow>
						<StyledTableCell className={clsx(classes.bgBlack, classes.noBorder)}>
							Global Grade
						</StyledTableCell>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										{'Cat/Level'}
									</StyledTableCell>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										Job Category
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableHead>
				<TableBody>
					{
						props.levelsData.map((levelData, i) => {
							return (
								<StyledTableRow key={i}>
									<StyledTableCell className={classes.bgBlack}>
										{i}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
									{
										props.groups.map(group => {
											const groupLevelData = levelData[group]
											const level = get(groupLevelData, 'level', '')
											return (
												<React.Fragment key={`${i}${group}`}>
													<StyledTableCell className={level ? classes.bgBlack : classes.bgWhite}>
														{get(groupLevelData, 'level', '')}
													</StyledTableCell>
													<StyledTableCell align="left" className={clsx(classes.leftJustified, level ? classes.bgBlack : classes.bgWhite)}>
														{get(groupLevelData, 'title', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.n', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.percent', '')}
													</StyledTableCell>
													<StyledTableCell className={classes.noBorder}>
													</StyledTableCell>
												</React.Fragment>
											)
										})
									}
								</StyledTableRow>
							)
						})
					}
                    <StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
					</StyledTableRow>
					<StyledTableRow>
						<StyledTableCell colSpan={1} className={classes.bgLightGreen} align='center'>Total {props.currentTotalN}</StyledTableCell>
						{
							Object.keys(props.groupSummary).map(key => {
								return (
									<React.Fragment key={key}>
										<StyledTableCell colSpan={3} className={classes.noBorder}></StyledTableCell>
										<StyledTableCell className={classes.bgLightGreen}>
											{props.groupSummary[key].current.totalN}
										</StyledTableCell>
										<StyledTableCell className={classes.bgLightGreen}>
											{props.groupSummary[key].current.totalPercent}
										</StyledTableCell>
									</React.Fragment>
								)
							})
						}
					</StyledTableRow>
					<StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map((group, j) =>
								<React.Fragment key={`gg${j}`}>
									<StyledTableCell colSpan={4} className={classes.noBorder}>
										<Graph key={`gg${j}`}
											data={props.graphsDataByGrades[group].reverse()}
											vAxisTitle={'Job Titles'}
											type={'LineChart'}
										/>
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
								</React.Fragment>
							)
						}
					</StyledTableRow>
				</TableBody>
			</Table>
		</div>
	)
}
